




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class CountryFlag extends Vue {
	@Prop({ required: false, type: String })
	private countryCode!: string | null;

	public get countryFlag(): string | null {
		if (!this.countryCode) {
			return null;
		}
		return `https://flagcdn.com/48x36/${this.countryCode.toLowerCase()}.png`;
	}
}
